import { Box } from "@mui/material";

function ZoomInAndHideAnimation() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        animation: "zoomInAndHide 1s ease-out forwards",
        "@keyframes zoomInAndHide": {
          "0%": {
            transform: "scale(0)",
            opacity: 1,
          },
          "100%": {
            transform: "scale(1)",
            opacity: 0,
          },
        },
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="98"
        height="98"
        viewBox="0 0 98 98"
        fill="none"
      >
        <path
          d="M79.965 32.475L94.56 22.885L96.21 21.8C96.99 21.29 97.465 20.41 97.465 19.48V2.745C97.465 2.075 97.23 1.46001 96.84 0.980011C96.78 0.915011 96.725 0.850018 96.675 0.800018C96.615 0.740018 96.56 0.68501 96.49 0.63501C96.01 0.24001 95.39 0 94.725 0H78C77.065 0 76.19 0.47501 75.67 1.26001L74.59 2.905L65 17.51L56.705 30.145L48.735 42.325L40.77 30.145L32.475 17.51L22.885 2.905L21.805 1.26001C21.285 0.47501 20.41 0 19.475 0H2.75C2.08 0 1.46 0.23501 0.979996 0.63501C0.914996 0.68501 0.850003 0.745018 0.800003 0.800018C0.740003 0.850018 0.689995 0.915011 0.634995 0.980011C0.244994 1.46001 0 2.075 0 2.745V19.48C0 20.415 0.479994 21.29 1.25999 21.8L2.90999 22.885L17.505 32.475L30.14 40.765L42.31 48.735L30.14 56.71L17.505 65.005L2.90999 74.585L1.25999 75.67C0.479994 76.18 0 77.06 0 77.99V94.72C0 95.39 0.244994 96.005 0.634995 96.485C0.694995 96.55 0.745003 96.615 0.800003 96.67C0.850003 96.72 0.914996 96.78 0.979996 96.83C1.46 97.225 2.08 97.465 2.75 97.465H19.475C20.41 97.465 21.285 96.99 21.805 96.205L22.885 94.56L32.475 79.955L40.77 67.32L48.74 55.15L56.705 67.32L65 79.955L74.59 94.56L75.67 96.205C76.19 96.99 77.065 97.465 78 97.465H94.725C95.39 97.465 96.01 97.23 96.49 96.83C96.56 96.78 96.62 96.72 96.675 96.67C96.725 96.61 96.785 96.55 96.84 96.485C97.23 96.005 97.465 95.39 97.465 94.72V77.99C97.465 77.055 96.99 76.18 96.21 75.67L94.56 74.585L79.965 65.005L67.33 56.71L55.15 48.735L67.33 40.765L79.965 32.475Z"
          fill="#3698BF"
        />
      </svg>
    </Box>
  );
}

export default ZoomInAndHideAnimation;
